import React from "react"

import styled from "styled-components"

const Styled = styled.button<{
  scheme: Schemes
}>`
  display: flex;
  gap: 5px;
  align-items: center;
  font-weight: 500;
  background: ${(props) => PILL_COLOR_SCHEMES[props.scheme].background};
  /* border: 1px solid ${(props) =>
    PILL_COLOR_SCHEMES[props.scheme].foreground}; */
  padding: 5px 12px;
  border-radius: 999px;
  cursor: pointer;
  &,
  * {
    cursor: pointer;
    text-transform: capitalize;
    color: ${(props) => PILL_COLOR_SCHEMES[props.scheme].foreground};
    font-size: 14px;
    white-space: nowrap;
  }
  [data-role="icon"] {
    text-transform: none;
    transform: translateY(-1px);
  }
`

export const PILL_COLOR_SCHEMES = {
  blue: {
    foreground: `var(--blue)`,
    background: `rgba(var(--blue-rgb), 0.15)`,
  },
  grey: {
    foreground: `var(--grey-dark)`,
    background: `#00000016`,
  },
  // https://mdigi.tools/color-shades/#147b2e - 10
  green: {
    foreground: `#126e29`,
    background: `#e9fbee`,
  },
  // https://mdigi.tools/color-shades/#79000d - 10
  red: {
    foreground: `#80000e`,
    background: `#ffe5e8`,
  },
}
type Schemes = keyof typeof PILL_COLOR_SCHEMES

export const Pill: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    children: React.ReactNode
    scheme?: Schemes
    clickable?: boolean
  }
> = ({ children, style, scheme = `blue`, clickable = true, ...props }) => {
  return (
    <Styled
      style={{
        ...style,
        cursor: clickable ? `pointer` : `inherit`,
      }}
      scheme={scheme}
      {...props}
    >
      {children}
    </Styled>
  )
}

export default Pill
